// extracted by mini-css-extract-plugin
export default {"page-header":"index_page-header__Nv3de"};